module.exports = __webpack_public_path__ + "img/title.00a3f3b3.svg";